var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Document_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86227 0.265747H6.8665C8.53418 0.265747 9.53298 1.27851 9.5375 2.9695V7.94166C9.5375 9.63265 8.54322 10.6454 6.87102 10.6454H5.38865C5.19854 10.6242 5.05464 10.4613 5.05464 10.2673C5.05464 10.0734 5.19854 9.91053 5.38865 9.88928H6.8665C8.14099 9.88928 8.78275 9.23396 8.78275 7.94166V2.9695C8.78275 1.6772 8.14099 1.02188 6.8665 1.02188H2.86227C1.58779 1.02188 0.941509 1.6772 0.941509 2.9695V7.94166C0.941509 9.23396 1.58779 9.88928 2.86227 9.88928C3.05238 9.91053 3.19628 10.0734 3.19628 10.2673C3.19628 10.4613 3.05238 10.6242 2.86227 10.6454C1.1946 10.6454 0.195801 9.63265 0.195801 7.94166V2.9695C0.195801 1.27393 1.1946 0.265747 2.86227 0.265747ZM2.99339 3.63859H4.41702C4.60712 3.61734 4.75102 3.45446 4.75102 3.26053C4.75102 3.06659 4.60712 2.90371 4.41702 2.88246H2.99339C2.80328 2.90371 2.65939 3.06659 2.65939 3.26053C2.65939 3.45446 2.80328 3.61734 2.99339 3.63859ZM6.73093 5.83365H2.99335H2.98883C2.79872 5.81239 2.65483 5.64951 2.65483 5.45558C2.65483 5.26165 2.79872 5.09877 2.98883 5.07751H6.73093C6.87394 5.06152 7.01337 5.12988 7.08982 5.25347C7.16627 5.37706 7.16627 5.5341 7.08982 5.65769C7.01337 5.78127 6.87394 5.84963 6.73093 5.83365ZM6.73116 8.02877H2.99358H2.98906C2.78438 8.02877 2.61846 7.86053 2.61846 7.65299C2.61846 7.44546 2.78438 7.27722 2.98906 7.27722H6.73116C6.93583 7.27722 7.10175 7.44546 7.10175 7.65299C7.10175 7.86053 6.93583 8.02877 6.73116 8.02877Z",
    fill: "#92929E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.5d73a6fa5039640392a18e212393ea95.svg";
export { ForwardRef as ReactComponent };